import SimpleTable from "../../../components/common/table/SimpleTable";
import SkeletonCustomTable from "../../../components/common/table/SkeletonCustomTable";
import { useGetDetailsBLExportQuery } from "../../../services/bl-export/BLExportService";

interface props {
  idBl: number;
}

const DetailBLExport = ({ idBl }: props) => {
  const { isLoading, isFetching, data } = useGetDetailsBLExportQuery(
    {
      id_bl: String(idBl),
      page: 0,
      pageSize: 50,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const headers = [
    "TIPO EMBALAJE",
    "CONTENEDOR",
    "# PAQUETES",
    "SELLOS",
    "MARCAS",
    "DESCRIPCIÓN ADICIONAL",
    "PESO NETO",
    "PESO BRUTO",
    "ESTADO PROCESAMIENTO",
  ];

  const rows =
    data?.detBl?.map((deta) => [
      deta.tipo_empaque,
      deta.cod_contenedor,
      deta.num_paquetes,
      <textarea style={{ flex: 1 }} value={deta.sellos} readOnly />,
      <textarea style={{ flex: 1 }} value={deta.ref_adicionales} readOnly />,
      <textarea style={{ flex: 1 }} value={deta.desc_ad_cont} readOnly />,
      deta.peso_neto,
      deta.peso_bruto,
      deta.estado_procesamiento === "L" ? "Procesado" : "No Procesado",
    ]) || [];

  if (isLoading || isFetching) {
    return <SkeletonCustomTable cellsCount={headers.length} rowsCount={5} />;
  }

  return (
    <div style={{ overflow: "auto" }}>
      <SimpleTable headers={headers} rows={rows} />
    </div>
  );
};

export default DetailBLExport;
